import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnodisingSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "anodising-sm" }), /* @__PURE__ */ _jsxs("g", {
		id: "Layer_2",
		"data-name": "Layer 2",
		children: [
			/* @__PURE__ */ _jsx("path", {
				className: "icon-white",
				d: "M92.15,61.56a.44.44,0,0,0,0-.16h0l-.06-.15,0,0L92,61.1l0,0A.69.69,0,0,0,91.8,61L50.23,37a.71.71,0,0,0-.72,0L8.2,60.81a.69.69,0,0,0-.13.11l0,0-.07.1,0,0-.06.15h0a.47.47,0,0,0,0,.17h0v4.32a.73.73,0,0,0,.36.63l41.57,24a.76.76,0,0,0,.72,0L91.8,66.53a.73.73,0,0,0,.36-.63V61.56Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M92.63,61.51a.73.73,0,0,0,0-.22l0-.07a.67.67,0,0,0-.1-.21l0-.06a1.1,1.1,0,0,0-.14-.18l0-.05a.87.87,0,0,0-.22-.17l-41.57-24a1.17,1.17,0,0,0-1.2,0L8,60.4a1.13,1.13,0,0,0-.23.17l-.05.06a1.09,1.09,0,0,0-.13.17l0,.06a1.89,1.89,0,0,0-.09.21v0a.69.69,0,0,0,0,.25v4.38a1.2,1.2,0,0,0,.6,1l41.57,24a1.21,1.21,0,0,0,1.2,0L92,66.94a1.2,1.2,0,0,0,.6-1V61.51ZM92,61.1Zm-43,25v1.54L9.76,65.06V63.51ZM89,61.58,50.13,84.05,11,61.43,49.87,39Zm1.2,2.08v1.55L51.33,87.67V86.13Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M38.57,19.45H32.3V13.18a1.2,1.2,0,1,0-2.4,0v6.27H23.63a1.2,1.2,0,1,0,0,2.4H29.9v6.27a1.2,1.2,0,1,0,2.4,0V21.85h6.27a1.2,1.2,0,1,0,0-2.4Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M76.37,19.45H61.43a1.2,1.2,0,0,0,0,2.4H76.37a1.2,1.2,0,1,0,0-2.4Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M31.1,44.9a1.19,1.19,0,0,0-1.2,1.19v3.84a1.2,1.2,0,0,0,2.4,0V46.09A1.19,1.19,0,0,0,31.1,44.9Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M31.1,52.57a1.2,1.2,0,0,0-1.2,1.2v3.84a1.2,1.2,0,0,0,2.4,0V53.77A1.2,1.2,0,0,0,31.1,52.57Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M31.1,60.25a1.2,1.2,0,0,0-1.2,1.2v.13a1.2,1.2,0,0,0,2.4,0v-.13A1.2,1.2,0,0,0,31.1,60.25Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M31.1,37.22a1.2,1.2,0,0,0-1.2,1.2v3.84a1.2,1.2,0,1,0,2.4,0V38.42A1.2,1.2,0,0,0,31.1,37.22Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M68.9,37.22a1.2,1.2,0,0,0-1.2,1.2v3.84a1.2,1.2,0,1,0,2.4,0V38.42A1.2,1.2,0,0,0,68.9,37.22Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M68.9,60.25a1.2,1.2,0,0,0-1.2,1.2v.13a1.2,1.2,0,1,0,2.4,0v-.13A1.2,1.2,0,0,0,68.9,60.25Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M68.9,44.9a1.19,1.19,0,0,0-1.2,1.19v3.84a1.2,1.2,0,1,0,2.4,0V46.09A1.19,1.19,0,0,0,68.9,44.9Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M68.9,52.57a1.2,1.2,0,0,0-1.2,1.2v3.84a1.2,1.2,0,0,0,2.4,0V53.77A1.2,1.2,0,0,0,68.9,52.57Z"
			})
		]
	})]
});
export default SvgAnodisingSm;
